import React from "react";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { VscMenu } from "react-icons/vsc";
import { CiSearch } from "react-icons/ci";

const Dermatologist = () => {
  return (
    <div className="w-full  py-4 border-[#efebe8] font-smalltech bg-white">
     CONSULT A DERMATOLOGIST TODAY
    </div>
  );
};

export default Dermatologist;
